import { State } from './reducer';

export const getReadyState = (state: State) => {
  return state.ready;
}

export const getLoadError = (state: State) => {
  return state.error;
}

export const getUserState = (state: State) => {
  return state.user;
}

export const getSearchState = (state: State) => {
  return state.search;
}

export const getMarketRegions = (state: State) => {
  return state.marketRegions;
}

export const getProviderList = (state: State) => {
  return state.providers;
}